import React from 'react';
import { t } from 'bv-i18n';

export default () => (
  <div className="fullscreen-message">
    <p />
    <div className="bvs-site-logo_large" />
    <p />
    <p className="fullscreen-message__text">{t('no_localstorage_support')}</p>
    <a className="fullscreen-message__reload" href="/">{t('reload_page')}</a>
  </div>
);
